export const TextQcFieldName = 'textQcFieldComponent';
